import {
  BiVizType,
  kBiDonutInnerRadius,
  kBiVizStyleOptionNames,
} from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleGroup } from '../StyleGroup';
import { StyleRow } from '../StyleRow';
import { biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

const kHoles: Array<{ value: number; label: string }> = [
  { value: 0, label: '实心' },
  { value: 0.4, label: '小' },
  { value: 0.6, label: '中' },
  { value: 0.8, label: '大' },
];

/** The hole in the middle and whether slices show their share. */
export const PieOptions = memo(
  ({
    style,
    type,
    onChange,
  }: BiStyleOptionProps & { type: BiVizType.Pie | BiVizType.Donut }) => {
    const pie = style?.pie ?? {
      innerRadius: type === BiVizType.Donut ? kBiDonutInnerRadius : 0,
      showPercent: false,
    };
    const set = (patch: Partial<typeof pie>) =>
      onChange(biWithStyleOption(style, 'pie', { ...pie, ...patch }));
    return (
      <StyleGroup
        title={kBiVizStyleOptionNames.pie}
        onReset={
          style?.pie
            ? () => onChange(biWithStyleOption(style, 'pie', undefined))
            : null
        }
      >
        <StyleRow label="中心孔">
          {kHoles.map(hole => (
            <BiChip
              key={hole.value}
              label={hole.label}
              selected={Math.abs(pie.innerRadius - hole.value) < 0.05}
              onPress={() => set({ innerRadius: hole.value })}
            />
          ))}
        </StyleRow>
        <StyleRow label="百分比">
          <BiChip
            label="显示"
            selected={pie.showPercent}
            onPress={() => set({ showPercent: true })}
          />
          <BiChip
            label="隐藏"
            selected={!pie.showPercent}
            onPress={() => set({ showPercent: false })}
          />
        </StyleRow>
      </StyleGroup>
    );
  },
);
